<button mat-icon-button (click)="toggleSidebar()">
  <mat-icon
    [class]="class()"
    class="sm:!text-white"
    [ngClass]="{'rotate-180': menuIsOpen}"
    >menu_open</mat-icon
  >
</button>
